import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Button from "../ui/Button";
import wastemarktLogo from "../../images/wastemarkt.svg";

const Hero = () => {
  return (
    <>
      <section className="container mx-auto px-5 py-8 md:py-12">
        <div className="flex flex-row justify-between items-center flex-wrap lg:flex-nowrap gap-12">
          <div className="lg:w-1/3">
            <h1 className="text-sm font-semibold uppercase subtitle-decorator text-gray-500 subtitle-decorator--dark mb-3">
              Skup elektroniki
            </h1>
            <h2 className="text-3xl md:text-5xl font-titles font-bold leading-none md:leading-snug mb-8">
              Zajmiemy się
              <br />
              <span className="text-secondary font-titles">Twoimi odpadami</span>
            </h2>
            <Button url="#o-nas">ZOBACZ</Button>
          </div>
          <div className="lg:w-2/3 flex flex-row justify-between flex-wrap lg:flex-nowrap space-x-8">
            <StaticImage src="../../images/banner2.jpg" alt="Banner" />
          </div>
        </div>
      </section>

      {/* Waste Markt Advertising Banner */}
      <section className="py-24 bg-gray-50 border-t border-b border-gray-100">
        <div className="container mx-auto px-5">
          <div className="flex flex-col md:flex-row items-stretch bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-500 hover:shadow-2xl hover:-translate-y-1">

            <div className="p-8 md:p-12 md:w-3/5 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-6">
                <span className="bg-secondary bg-opacity-10 text-secondary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                  Partner Projektu
                </span>
              </div>

              <h3 className="text-2xl md:text-4xl font-titles font-bold text-gray-900 mb-4 leading-tight">
                Giełda odpadów tworzyw sztucznych
              </h3>

              <p className="text-gray-500 mb-2 text-lg max-w-xl leading-relaxed">
                Innowacyjna platforma do handlu surowcami wtórnymi. Zadbaj o środowisko i zoptymalizuj zarządzanie odpadami razem z Waste Markt.
              </p>
            </div>

            <a
              href="https://wastemarkt.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="md:w-2/5 relative bg-secondary min-h-[320px] w-full flex items-center justify-center p-8 overflow-hidden group"
            >
              <div className="absolute inset-0 bg-black opacity-10 group-hover:opacity-0 transition-opacity duration-700"></div>

              {/* Decorative dynamic circles */}
              <div className="absolute top-0 right-0 -mr-24 -mt-24 w-72 h-72 rounded-full bg-white opacity-10 blur-2xl transform group-hover:scale-110 transition-transform duration-1000"></div>
              <div className="absolute bottom-0 left-0 -ml-24 -mb-24 w-80 h-80 rounded-full bg-black opacity-20 blur-2xl transform group-hover:-translate-x-4 transition-transform duration-1000"></div>

              <div className="relative z-10 flex flex-col items-center justify-center transform group-hover:scale-105 transition-transform duration-500">
                <div className="bg-white p-6 rounded-xl shadow-2xl mb-6">
                  <img
                    src={wastemarktLogo}
                    alt="Waste Markt Logo"
                    className="h-16 w-auto"
                  />
                </div>
                <div className="text-center">
                  <span className="block text-white font-titles font-semibold text-xl mb-1 drop-shadow-md">
                    Handel Surowcami
                  </span>
                  <span className="block text-white opacity-80 text-sm tracking-wide uppercase">
                    Platforma B2B
                  </span>
                </div>
              </div>
            </a>

          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
